import { Component, Ref, Vue, Watch, Prop } from 'vue-property-decorator'
import Inquiry from '@/inquiries/models/inquiry'
import inquiriesService from '@/inquiries/services/inquiries-service'
import InquiryDialog from '@/inquiries/components/inquiry-dialog/inquiry-dialog'
import InquiriesFilterRequest from '@/inquiries/models/inquiries-filter-request'
import InquiryContact from '@/inquiries/models/Inquiry-contact'
import * as texts from '@/app/utils/texts'
import ConfirmDialog from '@/app/components/confirm-dialog/confirm-dialog'

@Component
export default class InquiriesMine extends Vue {
  @Ref()
  private dialog!: InquiryDialog

  @Ref()
  private removeDialog!: ConfirmDialog

  @Ref()
  private contactDialog!: ConfirmDialog

  private contactText = texts.AskAcceptOfferText

  private loading: boolean = false
  private actionLoading: boolean = false
  private inquiries: Inquiry[] = []
  private filter: InquiriesFilterRequest = new InquiriesFilterRequest()

  private async findAsync() {
    this.loading = true
    this.filter.includeContacts = true
    const response = await inquiriesService.findAllAsync(this.filter)
    this.inquiries = response.items
    this.filter.pagination.totalItems = response.totalItems
    this.loading = false
  }

  private openNew() {
    const inquiry = new Inquiry()
    inquiry.creatorId = this.$auth.user
    this.dialog.openNew(inquiry)
  }

  private openEdit(inquiry: Inquiry) {
    this.dialog.openEdit(inquiry)
  }

  private openCopy(inquiry: Inquiry) {
    this.dialog.openNew(Inquiry.copy(inquiry))
  }

  private async create(inquiry: Inquiry) {
    await inquiriesService.saveAsync(inquiry)
    await this.findAsync()
  }

  private async update(inquiry: Inquiry) {
    await inquiriesService.updateAsync(inquiry)
    await this.findAsync()
  }

  private contactConfirm(inquiry: Inquiry) {
    this.contactDialog.open(inquiry)
  }

  private acceptConfirm(inquiry: Inquiry, contact: InquiryContact) {
    this.contactDialog.open({
      inquiry,
      contact,
    })
  }

  private async acceptContact(acceptObj: any) {
    this.actionLoading = true
    await inquiriesService.acceptContactAsync(
      acceptObj.contact.userId,
      acceptObj.inquiry
    )
    this.$router.push('/inquiries-closed')
    this.actionLoading = false
  }

  private removeConfirm(inquiry: Inquiry) {
    this.removeDialog.open(inquiry)
  }

  private async remove(inquiry: Inquiry) {
    this.loading = true
    await inquiriesService.removeAsync(inquiry.id)
    await this.findAsync()
    this.loading = false
  }

  private async reset() {
    this.filter.creatorId = this.$auth.user
    this.filter.takerId = null
    this.filter.state = null
    this.filter.radiusOfInterest = 0
    this.filter.includeContacts = true
    await this.findAsync()
  }

  private async created() {
    this.$bus.$on('inquiries-mine:reload', async () => await this.reset())
  }

  private async mounted() {
    await this.reset()
  }
}
